export default {
  close: 'Close',
  cancel: 'Cancel',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  submit: 'Submit',
  reset: 'Reset',
  download: 'download',
  dataIterator: {
    pageText: '{0}-{1} of {2}',
    noResultsText: 'No matching records found',
    loadingText: 'Loading items...',
  },
  dataTable: {
    itemsPerPageText: 'Rows per page:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    pageText: '{0}-{1} of {2}',
    itemsPerPageText: 'Items per page:',
    itemsPerPageAll: 'All',
    nextPage: 'Next page',
    prevPage: 'Previous page',
    firstPage: 'First page',
    lastPage: 'Last page',
  },
  datePicker: {
    itemsSelected: '{0} selected',
  },
  noDataText: 'No data available',
  carousel: {
    prev: 'Previous visual',
    next: 'Next visual',
  },
  calendar: {
    moreEvents: '{0} more',
  },
  sidebar: {
    dashboard: 'Dashboard',
    overview: 'Overview',
    general: 'General',
    machine: 'Machine',
    dataController: 'DataController',
    features: 'Features',
    weavingMachine: {
      title: 'Weaving Machine',
      settings: 'Settings',
      statistics: 'Statistics',
    },
    machineStats: {
      title: 'Machine Stats',
      overview: 'Overview',
      summarize: 'Summarize',
      statistics: 'Statistics',
      realtime: 'Realtime',
    },
    annotations: {
      title: 'Annotations',
      settings: 'Settings',
      form: 'Form',
    },
    views: 'Views',
    fullscreenStatistics: {
      title: 'Fullscreen Statistics',
      weavingMachine: 'Weaving Machine',
      overview: 'Overview',
    },
    settings: 'Settings',
    management: {
      title: 'Management',
      users: 'Users',
      groups: 'Groups',
    },
    support: 'Support',
    preferences: 'Preferences',
    feedback: 'Send feedback',
    help: 'Help',
  },
  machine: 'Machine',
  dataController: 'DataController',
  identifier: 'Identifier',
  name: 'Name',
  unit: 'Unit',
  factor: 'Factor',
  tag: 'Tag',
  actions: 'Actions',
  search: 'Search',
  newItem: 'New item',
  editItem: 'Edit item',
  weavingMachine: 'Weaving machine',
  frameSite: 'Frame site',
  frameDepth: 'Frame depth',
  frameColumn: 'Frame column',
  frameRow: 'Frame row',
  article: 'Article',
  initial: 'Initial',
  current: 'Current',
  percent: 'Percent',
  on: 'On',
  off: 'Off',
  working: 'Working',
  start: 'Start',
  stop: 'Stop',
  last: 'Last',
  day: 'Day',
  week: 'Week',
  month: 'Month',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  year: 'Year',
  all: 'All',
  default: 'Default',
  time: 'Time',
  produced: 'Produced',
  productionOverview: 'Production overview',
  generalInformation: 'General information',
  workingStatus: 'Working status',
  powerStatus: 'Power status',
  color: 'Color',
  text: 'Text',
  annotations: 'Annotations',
  annotation: 'Annotation',
  annotationForm: 'Annotation form',
  user: 'User',
  username: 'Username',
  password: 'Password',
  groups: 'Groups',
  group: 'Group',
  permissions: 'Permissions',
  preferences: 'Preferences',
  selectLanguage: 'Select language',
  darkTheme: 'Dark Theme',
  english: 'English',
  german: 'German',
  dataCube: 'DataCube',
  generalErrorMessage: 'An error has occurred',
  savedSuccessfully: '{0} was saved successfully',
  deletedSuccessfully: '{0} was deleted successfully',
  generalDeleteMessage: 'Are you sure you want to delete this item?',
  email: 'E-Mail',
  emailReports: 'E-Mail Reports',
  selectInterval: 'Select Interval',
  rules: {
    minLength: 'The min. length is {0} letters.',
  },
};
